import React, { Component } from 'react';
import { gantt } from 'dhtmlx-gantt';
import { TIGHT_FIT_PARAM } from 'constants/System';
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css';

export default class Gantt extends Component {
  componentDidMount() {
    const { tasks, width } = this.props;
    // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;

    gantt.config.readonly = true; // fantastic - one option to rule them all
    gantt.config.xml_date = '%d-%m-%Y %H:%i';
    gantt.config.date_grid = '%d-%m-%Y';
    gantt.config.scale_unit = 'month';
    gantt.config.date_scale = '%F, %Y';
    gantt.config.scale_height = 50;
    gantt.config.min_column_width = 45;
    gantt.config.subscales = [
      { unit: 'day', step: 1, date: '%j, %D' }
    ];
    if (width > TIGHT_FIT_PARAM) {
      gantt.config.columns = [{
        name: 'text',
        label: 'Initiatives',
        width: '*',
        tree: true
      },
      {
        name: 'start_date',
        label: 'Start time',
        align: 'center'
      },
      {
        name: 'duration',
        label: 'Duration',
        align: 'center'
      }];
    } else {
      gantt.config.columns = [{
        name: 'text',
        label: 'Initiatives',
        width: '200',
        tree: true
      }];
    }
    
    // gantt.attachEvent('onGanttReady', function(){
      // var tooltips = gantt.ext.tooltips;
      // tooltips.tooltip.setViewport(gantt.$task_data);
    // });
    gantt.templates.tooltip_text = function (task) {
      return '<b>Task:</b> ' + task.text + '<br/>';
    };

    gantt.init(this.ganttContainer);
    gantt.parse(tasks);
  }

  render() {
    return (
      <div
        ref={(input) => { this.ganttContainer = input; }}
        style={{ width: '100%', height: '400px' }}
      >

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/Gantt/Gantt.js